import { addChevronImagesToMap, createChevronLayer } from '../layers/chevrons';
import { addLayer, removeLayer } from '../layers/layer_helpers';

const addChevrons = (map, layerId, sourceId) => {
  if (map.getLayer(layerId)) {
    return;
  }

  // Add chevron images to map
  addChevronImagesToMap(map);

  // Add layer to map
  addLayer(map, createChevronLayer(layerId, sourceId));
};

const removeChevrons = (map, id) => {
  removeLayer(map, id);
};

export { addChevrons, removeChevrons };
